<template>
  <div id="page-back-add-bid">
    <div class="clear-fix">
      <div class="el-col content left">
        <el-scrollbar style="height: 100%;" :native="false" :wrapStyle="wrapStyle">
          <h3 class="title">公告正文</h3>
          <div class="grid-content origin-content">
            <quill-editor v-model="content" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)" @change="onEditorChange($event)">
            </quill-editor>
          </div>
        </el-scrollbar>

      </div>
      <div class="el-col content right">
        <el-scrollbar :native="false" style="height: 100%;">
          <h3 class="title">关键信息设置</h3>
          <div class="save-wrap">
            <el-alert class="left" title="双击要编辑的单元格进行编辑，编辑完成记得保存哦" type="warning" :closable="false" center
              show-icon></el-alert>
            <el-button class="right" type="primary" icon="el-icon-upload" @click="saveTenderingMessage()">保存
            </el-button>
          </div>
          <div class="grid-content update-area">
            <el-table :data="tableData" border @cell-dblclick="cellEdit" style="width: 99%;margin: 0 auto;">
              <el-table-column type="index"></el-table-column>
              <el-table-column prop="title" label="项目名称" width="160">
              </el-table-column>
              <el-table-column prop="content" label="项目内容">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.type === 1 && scope.row.content.edit" type="textarea" autosize ref="content"
                    v-model="scope.row.content.value" style="width: 100%"
                    @blur="scope.row.content.edit = false"></el-input>
                  <el-date-picker v-else-if="scope.row.type === 2 && scope.row.content.edit" v-model="scope.row.content.value"
                    ref="content" style="width: 100%" type="datetime" value-format="yyyy-MM-dd hh:mm:ss"
                    default-time="01:00:00" @blur="scope.row.content.edit = false"></el-date-picker>
                  <el-select v-else-if="scope.row.type === 3 && scope.row.content.edit" v-model="scope.row.content.value"
                    ref="content" clearable filterable placeholder="请选择"
                    @change="regionChange(scope.row.content.value, scope.row.propertyName)">
                    <el-option v-for="item in scope.row.options" :key="item.key" :label="item.value"
                      :value="item.value"></el-option>
                  </el-select>
                  <el-input-number v-else-if="scope.row.type === 5 && scope.row.content.edit"
                    v-model="scope.row.content.value" ref="content" style="width: 200px;" :precision="2" :step="10000"
                    :min="0"></el-input-number>
                  <span v-else>{{ scope.row.content.value }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="save-wrap">
            <el-alert class="left" title="编辑完成一定记得保存哦" type="warning" :closable="false" center show-icon></el-alert>
            <el-button class="right" type="primary" icon="el-icon-upload" @click="saveTenderingMessage()">
              保存
            </el-button>
          </div>
        </el-scrollbar>
      </div>
    </div>

    <el-dialog title="添加品目" :visible.sync="dialogAddVisible" width="50%" :before-close="closeAddTag">
      <el-form :model="addTagForm" style="width: 49%;float: left;">
        <el-form-item label="编码" label-width="100px">
          <el-input v-model="addTagForm.code" disabled autocomplete="off" style="width: 188px;"></el-input>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow >= 1" label="一级标签" label-width="100px">
          <el-select v-model="addTagForm.level_1" filterable default-first-option placeholder="请选择"
            @change="addTagChange($event, 1)">
            <el-option v-for="item in level_1" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow >= 2" label="二级标签" label-width="100px">
          <el-select v-model="addTagForm.level_2" filterable default-first-option placeholder="请选择"
            @change="addTagChange($event, 2)">
            <el-option v-for="item in level_2" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow >= 3" label="三级标签" label-width="100px">
          <el-select v-model="addTagForm.level_3" filterable default-first-option placeholder="请选择"
            @change="addTagChange($event, 3)">
            <el-option v-for="item in level_3" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow >= 4" label="四级标签" label-width="100px">
          <el-select v-model="addTagForm.level_4" filterable default-first-option placeholder="请选择"
            @change="addTagChange($event, 4)">
            <el-option v-for="item in level_4" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow >= 5" label="五级标签" label-width="100px">
          <el-select v-model="addTagForm.level_5" filterable default-first-option placeholder="请选择"
            @change="addTagChange($event, 5)">
            <el-option v-for="item in level_5" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow >= 6" label="六级标签" label-width="100px">
          <el-select v-model="addTagForm.level_6" filterable default-first-option placeholder="请选择"
            @change="addTagChange($event, 6)">
            <el-option v-for="item in level_6" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form style="width: 49%;float: right;">
        <el-tag :key="tag.code" v-for="(tag, index) in addTagList" closable :disable-transitions="false"
          @close="handleClose(index)">
          {{ tag.name }}
        </el-tag>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAddVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddTag">添加</el-button>
        <el-button type="primary" @click="confirmSaveAdd">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "backAddBid",
  data() {
    return {
      tableData: [],
      tenderingMessageId: '',
      tenderingMessageInfo: {},
      wrapStyle: {
        fontSize: '30px'
      },
      regionProvinceList: [],
      regionCityList: [],
      regionTownList: [],
      editorOption: {
        // Some Quill options...
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], //加粗，斜体，下划线，删除线
            ['blockquote', 'code-block'],  //引用，代码块
            [{ 'header': 1 }, { 'header': 2 }],  // 标题，键值对的形式；1、2表示字体大小
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],  //列表
            [{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
            [{ 'indent': '-1' }, { 'indent': '+1' }],  // 缩进
            [{ 'direction': 'rtl' }],    // 文本方向
            [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],  //几级标题
            [{ 'color': [] }, { 'background': [] }],  // 字体颜色，字体背景颜色
            [{ 'font': [] }],  //字体
            [{ 'align': [] }], //对齐方式
            ['clean'], //清除字体样式
            //['image','video'] //上传图片、上传视频
          ]
        },
        theme: 'snow',
        autoSaveTimer: null,
      },
      content: '',
      dialogAddVisible: false,
      level_1: [],
      level_2: [],
      level_3: [],
      level_4: [],
      level_5: [],
      level_6: [],
      addTagName: '',
      addTagCodeLength: 1,
      addTagForm: {
        levelSelectShow: 1,
        code: '',
        level_1: '',
        level_2: '',
        level_3: '',
        level_4: '',
        level_5: '',
        level_6: '',
        generalTerm: ['近义词', '同义词']
      },
      addTagList: [],
    }
  },
  computed: {},
  created() {
    //请求默认省市县数据
    this.$request.searchRegion().then(res2 => {
      console.log(res2);
      if (res2.status == 200) {
        res2.data.forEach((item) => {
          this.regionProvinceList.push(item);
        });

      } else {
        this.requestError(res2.status, res2.message)
      }
    }, err => {
      console.log(err)
      this.requestFail(err);
    })

    //格式化表格为所需要数据
    // type:1、字符串 2、日期 3、单选 4、多选 5、数字
    this.tableData = [
      {
        type: 1,
        propertyName: 'title',
        title: '标讯标题',
        content: {
          edit: false,
          value: ''
        },
      },
      {
        type: 1,
        propertyName: 'projectName',
        title: '项目名称',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'projectCode',
        title: '项目编号',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 2,
        propertyName: 'projectDate',
        title: '公告日期',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'expert',
        title: '评标专家',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'projectIntro',
        title: '项目简介',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 5,
        propertyName: 'bidMoney',
        title: '中标金额（元）',
        content: {
          edit: false,
          value: 0
        }
      },
      {
        type: 1,
        propertyName: 'item',
        title: '品目',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 3,
        propertyName: 'province',
        title: '省',
        content: {
          edit: false,
          value: ''
        },
        options: this.regionProvinceList
      },
      {
        type: 3,
        propertyName: 'city',
        title: '市',
        content: {
          edit: false,
          value: ''
        },
        options: this.regionCityList
      },
      {
        type: 3,
        propertyName: 'town',
        title: '县',
        content: {
          edit: false,
          value: ''
        },
        options: this.regionTownList
      },
      {
        type: 3,
        propertyName: 'subcontract',
        title: '分包情况',
        content: {
          edit: false,
          value: ''
        },
        options: [
          {
            id: 1,
            value: '已分包'
          },
          {
            id: 2,
            value: '未分包'
          }
        ]
      },
      {
        type: 5,
        propertyName: 'budgetMoney',
        title: '预算金额（元）',
        content: {
          edit: false,
          value: 0
        }
      },
      {
        type: 1,
        propertyName: 'companyName',
        title: '采购单位',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'companyContact',
        title: '采购单位联系人',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'companyAddress',
        title: '采购单位地址',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'companyTel',
        title: '采购单位电话',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'agencyName',
        title: '代理机构',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'agencyContact',
        title: '代理机构联系人',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'agencyAddress',
        title: '代理机构地址',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'agencyTel',
        title: '代理机构电话',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 3,
        propertyName: 'announcementTypeName',
        title: '公告类型',
        content: {
          edit: false,
          value: ''
        },
        options: (() => {
          let returnData = [];
          this.$request.searchAnnouncement().then(res => {
            console.log(res);
            if (res.status == 200) {
              res.data.forEach(item => {
                returnData.push(item)
              })
            } else {
              this.requestError(res.status, res.message)
            }
          }, err => {
            console.log(err)
            this.requestFail(err);
          })

          return returnData
        })()
      },
      {
        type: 3,
        propertyName: 'purchaseTypeName',
        title: '采购方式',
        content: {
          edit: false,
          value: ''
        },
        options: (() => {
          let returnData = [];
          this.$request.searchPurchase().then(res => {
            console.log(res);
            if (res.status == 200) {
              res.data.forEach(item => {
                returnData.push(item)
              })
            } else {
              this.requestError(res.status, res.message)
            }
          }, err => {
            console.log(err)
            this.requestFail(err);
          })

          return returnData
        })()
      },
      {
        type: 3,
        propertyName: 'purchaserName',
        title: '采购人类型',
        content: {
          edit: false,
          value: ''
        },
        options: (() => {
          let returnData = [];
          this.$request.searchPurchaser().then(res => {
            console.log(res);
            if (res.status == 200) {
              res.data.forEach(item => {
                returnData.push(item)
              })
            } else {
              this.requestError(res.status, res.message)
            }
          }, err => {
            console.log(err);
            this.requestFail(err);
          })
          // console.log(returnData)
          return returnData
        })()
      },
      {
        type: 1,
        propertyName: 'winningBidder',
        title: '供应商',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'brand',
        title: '品牌',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'productType',
        title: '产品类型',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'marketSegments',
        title: '细分市场',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'getBidDocTime',
        title: '获取招标文件时间',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'getBidDocAddress',
        title: '获取招标文件地点',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 2,
        propertyName: 'bidOpeningTime',
        title: '开标时间',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'bidOpeningAddress',
        title: '开标地点',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 2,
        propertyName: 'bidEndTime',
        title: '投标截止日期',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 2,
        propertyName: 'estimatedPurchaseTime',
        title: '预计采购时间',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 1,
        propertyName: 'intentionOfProject',
        title: '项目所在采购意向',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 2,
        propertyName: 'winDate',
        title: '中标日期',
        content: {
          edit: false,
          value: ''
        }
      },
      {
        type: 2,
        propertyName: 'changeDate',
        title: '标讯更正日期',
        content: {
          edit: false,
          value: ''
        }
      }
    ];
  },
  methods: {
    handleClose(index) {//删除已添加品目
      console.log(index)
      this.addTagList.splice(index, 1);
    },
    addNewTag() {//点击添加标签
      this.$request.listItemChildren().then(res => {
        // console.log(res);
        if (res.status == 200) {
          this.level_1 = res.data;
          this.dialogAddVisible = true;
        } else {
          this.requestError(res.status, res.message)
        }
      }, err => {
        console.log(err);
        this.requestFail(err);
      });
    },
    closeAddTag() {
      this.dialogAddVisible = false;
    },
    addTagChange(val, level) {
      console.log(val, level);
      this['level_' + level].forEach(item => {
        if (val == item.code) {
          this.addTagName = item.name
        }
      });
      this.addTagForm.code = val;
      this.addTagForm.levelSelectShow = level + 1;
      this.$request.listItemChildren({
        code: val
      }).then(res => {
        // console.log(res);
        if (res.status == 200) {
          this['level_' + (level + 1)] = res.data;

          for (let i = level; i < 6; i++) {
            if (this['level_' + (i + 2)] && this['level_' + (i + 2)].length > 0) {
              this['level_' + (i + 2)] = [];
            }
            this.addTagForm['level_' + (i + 1)] = '';
            // console.log(this.addTagForm)
          }
        } else {
          this.requestError(res.status, res.message)
        }
      }, err => {
        console.log(err);
        this.requestFail(err);
      });
    },
    confirmSaveAdd() {
      this.tableData.forEach((item) => {
        if (item.propertyName == 'item') {
          let itemStr = '';
          this.addTagList.forEach(item => {
            itemStr += item.name + '、';
          });
          item.content.value = itemStr.substring(0, itemStr.length - 1);
        }
      })
      this.dialogAddVisible = false;
    },
    confirmAddTag() {
      if (this.addTagForm.code.length > 1) {
        if (!this.addTagList.some(item => {
          return item.code === this.addTagForm.code
        }, this)) {
          this.addTagList.push({
            code: this.addTagForm.code,
            name: this.addTagName
          })
        } else {
          this.$message({
            type: 'warning',
            message: '已经添加过该品目了！'
          })
        }
      } else {
        this.$message({
          type: 'warning',
          message: '请选择！'
        })
      }
    },
    onEditorBlur(quill) {
      console.log('editor blur!', quill)
    },
    onEditorFocus(quill) {
      console.log('editor focus!', quill)
    },
    onEditorReady(quill) {
      console.log('editor ready!', quill)
    },
    onEditorChange({ quill, html, text }) {
      console.log('editor change!', quill, html, text)
      this.content = html
    },
    regionChange(value, level) {//地区选择改变时触发
      // console.log(value,level)
      if (level == 'province') {
        // console.log(value,this.regionProvinceList)
        if (value == '') {
          this.tableData.forEach((item) => {
            if (item.propertyName == 'city') {
              item.content.value = '';
              item.options = [];
            } else if (item.propertyName == 'town') {
              item.content.value = '';
              item.options = [];
            }
          })
        } else {
          this.regionProvinceList.forEach((item) => {
            if (value == item.value) {
              console.log(item.id);
              this.$request.searchRegion({
                level: 2,
                parentCode: item.key
              }).then(res => {
                console.log(res)
                if (res.status == 200) {
                  this.regionCityList = res.data;
                  this.tableData.forEach((item) => {
                    if (item.propertyName == 'city') {
                      item.content.value = '';
                      item.options = res.data;
                    } else if (item.propertyName == 'town') {
                      item.content.value = '';
                      item.options = [];
                    }
                  })
                } else {
                  this.requestError(res.status, res.message)
                }
              }, err => {
                console.log(err)
              })

            }
          })
        }

      } else if (level == 'city') {
        console.log(value);
        if (value == '') {
          this.tableData.forEach((item) => {
            if (item.propertyName == 'town') {
              item.content.value = '';
              item.options = [];
            }
          })
        } else {
          this.regionCityList.forEach((item) => {
            if (value == item.value) {
              console.log(item.key);
              this.$request.searchRegion({
                level: 3,
                parentCode: item.key
              }).then(res => {
                console.log(res);
                if (res.status == 200) {
                  this.regionTownList = res.data;
                  this.tableData.forEach((item) => {
                    if (item.propertyName == 'town') {
                      item.content.value = '';
                      item.options = res.data;
                    }
                  })
                } else {
                  this.requestError(res.status, res.message)
                }
              }, err => {
                console.log(err)
              })

            }
          })
        }

      }
    },
    formatData() {
      this.tableData.forEach(item => {
        for (let key in item) {
          item[key] = {
            value: item[key],
            edit: false
          }
        }
      })
      console.log(this.tableData)
    },
    cellEdit(row, column, cell, event) {
      console.log(row, column, cell, event);
      if (row.propertyName == 'item') {
        this.addNewTag();
        this.dialogAddVisible = true;
      }
      if (column.property == 'content') {
        row[column.property].edit = true;
        setTimeout(() => {
          this.$refs[column.property].focus()
        }, 20)
      }
    },
    saveTenderingMessage() {//储存修改的信息
      let data = {};
      this.tableData.forEach((item) => {
        if (item.propertyName == 'bidMoney' || item.propertyName == 'budgetMoney') {
          data[item.propertyName] = item.content.value * 100
        } else if (item.propertyName == 'item') {
          let itemCodes = [];
          this.addTagList.forEach(item => {
            itemCodes.push(item.code);
          })
          data.itemCodes = itemCodes;
        } else {
          data[item.propertyName] = item.content.value;
        }
      })
      data.bidContent = this.content;
      // console.log(data)
      if (data.bidContent && data.projectDate && data.projectName) {
        let loading = this.$loading(this.utils.defaultLoadingOptions);
        this.$request.addBid(
          data
        ).then(res => {
          console.log(res)
          loading.close();
          if (res.status == 200) {
            if (res.data == 1) {
              this.$message({
                type: 'success',
                message: '保存成功！'
              });
              this.$router.go(-1);
            } else {
              this.$message({
                type: 'warning',
                message: '保存失败！'
              });
            }
          } else {
            this.requestError(res.status, res.message)
          }
        }, err => {
          console.log(err);
          loading.close();
          this.requestFail(err);
        })
      } else {
        this.$message({
          type: 'error',
          message: '公告正文、项目名称、公告日期为必填字段！'
        });
      }
    }
  }
}
</script>

<style lang="less" scoped>
#page-back-add-bid {
  .height();
  padding: 20px;
  min-width: 1300px;
  background-color: #e6e6e6;

  &>div {
    height: 100%;
  }

  .el-col.content {
    width: 49.8%;
    height: 100%;
    overflow: hidden;
    background-color: #ffffff;
    .box-shadow();
    .border-radius(5px);

    .quill-editor {
      height: 660px;
    }

    h3.title {
      font-size: 20px;
      text-align: center;
      margin: 20px;
    }

    .save-wrap {
      width: 100%;
      padding-right: 5px;

      .el-alert {
        width: 90%;
        min-width: 610px;
      }

      .el-button {
        width: 10%;
        min-width: 80px;
      }
    }

    .origin-content {
      padding: 20px;
    }

    table {
      width: 100%;

      .row-title {
        width: 20%;
        line-height: 50px;
        text-align: center;
        background-color: #EEF1F6;

        &.row-content {
          width: 80%;
        }
      }

      .item-title {
        /*min-width: 20%;*/
        line-height: 50px;
        background-color: #EEF1F6;
      }

      .item-content {
        /*max-width: 80%;*/
        line-height: 50px;
        word-break: break-all;
      }
    }
  }

}
</style>
<style lang="less">
#page-back-add-bid {
  .el-dialog {
    .el-dialog__body {
      .clearfix;
    }

    .el-tag {
      margin-left: 10px;
    }
  }
}
</style>